<template>
  <fade-transition>
    <div class="about-modal">
      <div class="modal-body">
        <div class="filters-header">
          <p class="method-title">FILTRY {{ category }}</p>
          <button class="modal-close-btn" @click.prevent="hideFilters">
            {{ $t("cross") }}
          </button>
        </div>
        <div class="filters-content">
          <MultiFilter
            :output="pushFilters"
            filter="publication_year"
          ></MultiFilter>
          <MultiFilter
            :output="pushFilters"
            filter="journal_title"
          ></MultiFilter>
          <MultiFilter :output="pushFilters" filter="authors"></MultiFilter>
          <div
            class="justify-content-md-center"
            v-for="item in mod_filters"
            :key="item.id"
            :class="item"
          >
            <FilterProperty
              :input="item"
              :output="pushFilters"
            ></FilterProperty>
          </div>
        </div>
      </div>
    </div>
  </fade-transition>
</template>

<script>
import axios from "axios";
import VueAxios from "vue-axios";
import FadeTransition from "@/components/FadeTransition.vue";
import FilterProperty from "@/components/FilterProperty";
import MultiFilter from "@/components/MultiFilter";
import Authors from "@/components/Authors";
import InputTag from "vue-input-tag";
import { i18n } from "../translations";

export default {
  name: "TaskFilter",
  props: ["output", "visible", "category"],
  data() {
    return {
      show: false,
      task: {
        id: null,
        status: "",
        result: "",
        finished: false,
      },
      all_filters: null,
      mod_filters: null,
      metadata_filters: [],
    };
  },
  components: {
    MultiFilter,
    FilterProperty,
    axios,
    VueAxios,
    FadeTransition,
    Authors,
  },
  methods: {
    getTaskId: async function () {
      try {
        let response = await axios.post(
          process.env.ROOT_API + "startTask",
          {
            task_type: "dictionaries",
            metadata_filter: [],
            query_parameters: [
              {
                name: "dictionaries",
                value: "true",
              },
            ],
            response_parameters: [],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
            crossDomain: true,
            timeout: 5000,
          }
        );
        this.task.id = response.data.id;
        this.checkStatus(this.task.id, 100);
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    checkStatus: async function (taskId, timer) {
      try {
        timer += 100;
        let response = await axios.get(
          process.env.ROOT_API + "getStatus/" + taskId,
          { timeout: 1000 }
        );
        this.task.status = response.data.status;
        if (this.task.status === "DONE") {
          this.getResult(taskId);
        } else if (this.task.status === "QUEUE") {
          setTimeout(() => {
            this.checkStatus(taskId, timer);
          }, timer);
        }
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    getResult: async function (taskId) {
      try {
        let response = await axios.get(
          process.env.ROOT_API + "getResult/" + taskId,
          { timeout: 5000 }
        );
        let propertyNames = [];
        response.data.result.dictionaries.property_names.forEach(function (
          value,
          i
        ) {
          // two exceptions due to much data             value !== "authors" &&
          if (
            value !== "article_title" &&
            value !== "publication_day" &&
            value !== "publication_month" &&
            value !== "journal_title" &&
            value !== "authors" &&
            value !== "publication_year"
          ) {
            propertyNames.push(
              response.data.result.dictionaries.property_names[i]
            );
          }
        });
        this.mod_filters = JSON.parse(JSON.stringify(propertyNames));
        this.all_filters = propertyNames;
        this.all_filters.push("authors");
        this.all_filters.push("journal_title");
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    pushFilters: function (request, input) {
      try {
        this.metadata_filters[input] = request;

        this.output(this.metadata_filters, this.all_filters);
      } catch (e) {
        console.log(Object.keys(e), e.message);
      }
    },
    hideFilters: function () {
      this.visible(false);
    },
  },
  created() {
    this.visible(false);
    if (this.all_filters === null) {
      this.getTaskId();
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.about-modal {
  background-color: var(--grey_alpha_old);
  z-index: 5000;
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
}
.modal-close-btn {
  width: 25px;
  background-color: rgba(255, 255, 255, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
}
.modal-close-btn:hover {
  font-size: 1.2rem;
}
.modal-body {
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  background-color: white;
  overflow-y: auto;
  padding: 20px;
}
.filters-header {
  display: flex;
  align-items: flex-start;
  background-color: var(--white_grey);
  align-items: center;
  border-radius: 5px;
  margin-bottom: 8px;
  padding-right: 4px;
}
.method-title {
  display: flex;
  width: 100%;
  font-weight: bold;
  color: var(--grey_black);
  margin: 6px;
  justify-content: center;
}
.box-close-btn {
  width: 25px;
  background-color: rgba(255, 255, 255, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
}
@media only screen and (min-width: 768px) {
  .modal-body {
    top: 0;
    right: 0;
    width: 50%;
    max-height: 80%;
    margin: 5% auto;
    background-color: white;
    overflow-y: auto;
  }
}

@media only screen and (max-width: 768px) {
  .about-modal {
    top: 0;
    right: 0;
    height: initial;
    max-height: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TaskFilter.vue